/* ============================================================
   MAISON FLASH — theme.js
   Panier AJAX + drawer, menu mobile, variantes, galerie, reveal.
   Vanilla JS, sans dépendance.
   ============================================================ */
(function () {
  'use strict';
  var MF = window.MaisonFlash || {};
  var routes = MF.routes || {};

  /* ---------- Utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  /* Portée MODULE : renderDrawer l'appelle aussi. Déclarée dans un bloc,
     'use strict' la rendait invisible au panier (ReferenceError). */
  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || MF.moneyFormat || '{{amount}} €';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(number, precision, thousands, decimal) {
      precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var n = (Math.abs(number) / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var match = fmt.match(placeholder);
    var t = match ? match[1] : 'amount';
    switch (t) {
      case 'amount': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals': value = num(cents, 0, ' ', ','); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ''); break;
      default: value = num(cents, 2, ' ', ',');
    }
    return fmt.replace(placeholder, value);
  }
  MF.formatMoney = formatMoney;

  /* ---------- Garde icône « Mon compte » ----------
     L'app fidélité (Joy) détourne le clic sur le compte pour ouvrir son panneau.
     On intercepte en phase de capture, le plus tôt possible, pour aller
     directement à la page compte. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-account-guard]');
    if (!a) return;
    e.stopImmediatePropagation();
    var href = a.getAttribute('href');
    if (href) window.location.href = href;
  }, true);

  /* ---------- Pastilles couleur sur les cartes (page collection) ----------
     Au clic sur une pastille portant une image de variante, on remplace l'image
     principale de la carte par celle de la couleur, SANS ouvrir la fiche.
     Les pastilles sans image (variante non illustrée) restent décoratives. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.cswatch[data-swatch-src]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.mfc-card') || sw.closest('.card');
    if (!card) return;
    // Image principale : .card__media--main (fiches/mises en avant) OU .mfc-card__img (collection).
    var main = card.querySelector('.card__media--main, .mfc-card__img:not(.mfc-card__img--hover)');
    if (!main) return;
    if (main.getAttribute('src') === sw.getAttribute('data-swatch-src')) {
      // déjà affichée : on met juste l'état actif à jour
    } else {
      main.src = sw.getAttribute('data-swatch-src');
      var ss = sw.getAttribute('data-swatch-srcset');
      if (ss) { main.srcset = ss; } else { main.removeAttribute('srcset'); }
      // Couleur fixée : on fige l'image au survol (pas de retour à la 2e image par défaut).
      card.classList.add('is-swatched');
    }
    var group = sw.closest('[data-card-swatches]') || card;
    group.querySelectorAll('.cswatch').forEach(function (s) {
      s.classList.remove('is-active');
      s.removeAttribute('aria-current');
    });
    sw.classList.add('is-active');
    sw.setAttribute('aria-current', 'true');
  });

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' + msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Body lock (drawer/menu) ---------- */
  var lockCount = 0;
  function lockBody() { lockCount++; document.body.classList.add('body--locked'); }
  function unlockBody() { lockCount = Math.max(0, lockCount - 1); if (lockCount === 0) document.body.classList.remove('body--locked'); }

  /* Focus trap simple */
  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    var focusables = $all('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  var drawer = $('#CartDrawer');
  var drawerBody = drawer ? $('[data-cart-body]', drawer) : null;
  var lastFocused = null;

  function setExpanded(sel, val) { $all(sel).forEach(function (b) { b.setAttribute('aria-expanded', val ? 'true' : 'false'); }); }
  function openDrawer() {
    if (!drawer) return;
    if (drawer.getAttribute('aria-hidden') === 'false') return; // déjà ouvert : ne pas re-verrouiller
    lastFocused = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    setExpanded('[data-cart-toggle]', true);
    lockBody();
    var closeBtn = $('[data-cart-close]', drawer);
    setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer) return;
    if (drawer.getAttribute('aria-hidden') === 'true') return; // déjà fermé : ne pas déverrouiller en trop
    drawer.setAttribute('aria-hidden', 'true');
    setExpanded('[data-cart-toggle]', false);
    unlockBody();
    if (lastFocused) lastFocused.focus();
  }
  window.MaisonFlashOpenCart = openDrawer;

  if (drawer) {
    on(drawer, 'click', function (e) {
      if (e.target.closest('[data-cart-close]')) closeDrawer();
    });
    on(document, 'keydown', function (e) {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        if (e.key === 'Escape') closeDrawer();
        else trapFocus(drawer, e);
      }
    });
  }

  /* Build drawer HTML from cart JSON */
  function renderDrawer(cart) {
    if (!drawerBody) return;
    var threshold = MF.freeShippingThreshold || 0;
    if (!cart || !cart.items || cart.item_count === 0) {
      drawerBody.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2l2.4 12.2a1.5 1.5 0 0 0 1.5 1.2h8.7a1.5 1.5 0 0 0 1.5-1.2L21 8H6"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>' +
        '<p>' + (MF.strings.cartEmpty || 'Votre panier est vide pour l\'instant. Vos compagnons méritent mieux !') + '</p>' +
        '<a href="' + (routes.shop_url || '/collections/all') + '" class="btn btn--accent" data-cart-close>Découvrir la boutique</a>' +
        '</div>';
      updateCartReco(cart);
      return;
    }
    var html = '<div class="cart-drawer__scroll">';
    if (threshold > 0) {
      var remaining = threshold - cart.total_price;
      var pct = Math.min(100, cart.total_price * 100 / threshold);
      html += '<div class="ship-bar"><div class="ship-bar__label">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>' +
        (remaining > 0 ? (MF.strings.shipProgress || 'Plus que [montant] pour la livraison offerte !').replace('[montant]', '<strong>' + formatMoney(remaining) + '</strong>') : (MF.strings.shipUnlocked || 'Bravo, la livraison vous est offerte !')) +
        '</div><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
    }
    html += '<div class="cart-drawer__lines">';
    cart.items.forEach(function (item) {
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? '<div class="drawer-line__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      var img = item.image ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_140x$1') + '" alt="" width="70" height="70" decoding="async" fetchpriority="high">' :
        '<div class="card__media-ph"><span class="ph-mark" style="font-size:.58rem;letter-spacing:.06em">' + (MF.shopName || 'Maison Flash') + '</span></div>';
      html += '<div class="drawer-line" data-key="' + item.key + '">' +
        '<a class="drawer-line__img" href="' + item.url + '">' + img + '</a><div>' +
        '<a href="' + item.url + '"><div class="drawer-line__title">' + escapeHtml(item.product_title) + '</div></a>' + variant +
        '<div class="drawer-line__bottom"><div class="qty qty--sm" data-qty>' +
        '<button type="button" data-qty-minus aria-label="Diminuer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
        '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantité" data-qty-input data-key="' + item.key + '">' +
        '<button type="button" data-qty-plus aria-label="Augmenter"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div><span class="drawer-line__price">' + formatMoney(item.final_line_price) + '</span></div>' +
        '<button type="button" class="drawer-line__remove" data-remove data-key="' + item.key + '">Retirer</button>' +
        '</div></div>';
    });
    html += '</div></div>';
    drawerBody.innerHTML = html;
    updateCartReco(cart);
  }

  /* Complémentaires du panier (Search & Discovery) — remplit [data-cart-reco]
     selon le contenu du panier. Repli : le cross-sell collection statique. */
  function updateCartReco(cart) {
    var box = document.querySelector('[data-cart-reco]');
    if (!box) return;
    var list = box.querySelector('[data-cart-reco-list]');
    var fallback = document.querySelector('[data-cart-upsell]');
    function syncAside() {
      var has = (!box.hidden && list && list.children.length) || (fallback && !fallback.hidden && fallback.querySelector('.xsell__item'));
      if (drawer) drawer.classList.toggle('cart-drawer--has-aside', !!has);
    }
    function showFallback() { box.hidden = true; if (list) list.innerHTML = ''; if (fallback) fallback.hidden = false; syncAside(); }
    if (!cart || !cart.items || !cart.items.length) { showFallback(); return; }
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var baseId = cart.items[0].product_id;
    var base = routes.product_recommendations_url || '/recommendations/products';
    var url = base + '?section_id=cart-recommendations&product_id=' + baseId + '&intent=complementary&limit=6';
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (htmlStr) {
        if (!htmlStr) { showFallback(); return; }
        var doc = new DOMParser().parseFromString(htmlStr, 'text/html');
        var items = $all('.xsell__item', doc).filter(function (el) { return !inCart[el.getAttribute('data-reco-id')]; }).slice(0, 3);
        if (!items.length) { showFallback(); return; }
        if (list) { list.innerHTML = ''; items.forEach(function (el) { list.appendChild(el); }); }
        box.hidden = false;
        if (fallback) fallback.hidden = true; /* un seul cross-sell à la fois */
        syncAside();
      })
      .catch(function () { showFallback(); });
  }

  function updateCartFoot(cart) {
    var total = $('[data-cart-total]');
    if (total) total.innerHTML = formatMoney(cart && cart.total_price ? cart.total_price : 0);
    if (drawer) drawer.classList.toggle('is-empty', !cart || cart.item_count === 0);
  }

  function updateCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function getCart() {
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshCart(open) {
    return getCart().then(function (cart) {
      renderDrawer(cart);
      updateCartFoot(cart);
      updateCartCount(cart.item_count);
      if (open) openDrawer();
      return cart;
    });
  }

  /* Add to cart */
  function addToCart(formData, button) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || MF.strings.cartError || 'Erreur'); return; }
        return refreshCart(true).then(function () { toast('Ajouté au panier !'); });
      })
      .catch(function () { toast(MF.strings.cartError || 'Une erreur est survenue'); })
      .finally(function () { if (button) { button.classList.remove('is-loading'); button.disabled = false; } });
  }

  /* Change quantity by line key */
  var cartBusy = false;
  function changeQty(key, quantity) {
    // champ vidé par la cliente : on ne touche pas au panier
    if (quantity === null || quantity === undefined) return Promise.resolve();
    // sérialisation : deux clics rapides sur +/- envoyaient deux requêtes
    // calculées sur la MÊME valeur du DOM, la seconde écrasait la première.
    if (cartBusy) return Promise.resolve();
    cartBusy = true;
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || !res.data.items) {
          toast((res.data && res.data.description) || MF.strings.cartError || 'Une erreur est survenue');
          return refreshCart(false);
        }
        var cart = res.data;
        renderDrawer(cart);
        updateCartFoot(cart);
        updateCartCount(cart.item_count);
        // Sync page panier si présent
        if (document.body.classList.contains('template-cart')) window.location.reload();
        return cart;
      })
      .catch(function () { toast(MF.strings.cartError || 'Une erreur est survenue'); })
      .finally(function () { cartBusy = false; });
  }

  /* Delegated events inside drawer */
  if (drawer) {
    on(drawer, 'click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      var remove = e.target.closest('[data-remove]');
      if (remove) { changeQty(remove.getAttribute('data-key'), 0); return; }
      if (minus || plus) {
        var qtyWrap = (minus || plus).closest('[data-qty]');
        var input = $('[data-qty-input]', qtyWrap);
        var val = parseInt(input.value, 10) || 0;
        val = minus ? Math.max(0, val - 1) : val + 1;
        changeQty(input.getAttribute('data-key'), val);
      }
    });
    on(drawer, 'change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (input) changeQty(input.getAttribute('data-key'), (input.value === '' ? null : Math.max(0, parseInt(input.value, 10) || 0)));
    });
  }

  /* Cart triggers (icône header) */
  $all('[data-cart-toggle]').forEach(function (btn) {
    on(btn, 'click', function (e) { e.preventDefault(); openDrawer(); });
  });

  /* Product forms */
  $all('form[data-product-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      e.preventDefault();
      var btn = $('[data-atc]', form);
      addToCart(new FormData(form), btn);
    });
  });

  /* ============================================================
     MENU MOBILE
     ============================================================ */
  var mobileMenu = $('#MobileMenu');
  function openMenu() { if (!mobileMenu) return; if (mobileMenu.getAttribute('aria-hidden') === 'false') return; mobileMenu.setAttribute('aria-hidden', 'false'); setExpanded('[data-menu-toggle]', true); lockBody(); setTimeout(function () { var c = $('[data-menu-close]', mobileMenu); if (c) c.focus(); }, 60); }
  function closeMenu() { if (!mobileMenu) return; if (mobileMenu.getAttribute('aria-hidden') === 'true') return; mobileMenu.setAttribute('aria-hidden', 'true'); setExpanded('[data-menu-toggle]', false); unlockBody(); }
  $all('[data-menu-toggle]').forEach(function (b) { on(b, 'click', openMenu); });
  if (mobileMenu) {
    on(mobileMenu, 'click', function (e) { if (e.target.closest('[data-menu-close]')) closeMenu(); });
    on(document, 'keydown', function (e) {
      if (mobileMenu.getAttribute('aria-hidden') === 'false') {
        if (e.key === 'Escape') closeMenu(); else trapFocus(mobileMenu, e);
      }
    });
  }

  /* ============================================================
     MÉGA-MENU (rubriques à sous-menus du header)
     Survol géré en CSS (hover: hover) ; ici : tap tactile,
     Échap et clic extérieur. Un seul panneau ouvert à la fois.
     ============================================================ */
  var navItems = $all('[data-nav-item]');
  function closeAllMega(except) {
    navItems.forEach(function (it) {
      if (it === except) return;
      it.classList.remove('is-open');
      var btn = $('.nav-item__btn', it);
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }
  navItems.forEach(function (item) {
    var btn = $('.nav-item__btn', item);
    if (!btn) return;
    on(btn, 'click', function () {
      var isOpen = item.classList.contains('is-open');
      closeAllMega(item);
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
  if (navItems.length) {
    on(document, 'click', function (e) { if (!e.target.closest('[data-nav-item]')) closeAllMega(); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeAllMega(); });
  }

  /* ============================================================
     QUANTITY STEPPERS (hors drawer, ex : fiche produit)
     ============================================================ */
  $all('[data-qty]').forEach(function (wrap) {
    if (wrap.closest('#CartDrawer')) return;
    on(wrap, 'click', function (e) {
      var input = $('input', wrap);
      if (!input) return;
      var isMinus = e.target.closest('[data-qty-minus]');
      var isPlus = e.target.closest('[data-qty-plus]');
      if (!isMinus && !isPlus) return;
      var min = parseInt(input.min || 1, 10);
      if (isMinus) input.value = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
      if (isPlus) input.value = (parseInt(input.value, 10) || 1) + 1;
      var cartInput = input.matches('[data-cart-qty]') ? input : null;
      if (cartInput) changeQty(cartInput.getAttribute('data-key'), parseInt(cartInput.value, 10) || 0);
    });
  });
  // Page panier : saisie directe
  $all('[data-cart-qty]').forEach(function (input) {
    on(input, 'change', function () {
      changeQty(input.getAttribute('data-key'), (input.value === '' ? null : Math.max(0, parseInt(input.value, 10) || 0)));
    });
  });

  /* ============================================================
     FICHE PRODUIT : variantes + galerie
     ============================================================ */
  $all('[data-product]').forEach(function (root) {
    var dataEl = $('[data-variants-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('form[data-product-form]', root);
    var idInput = form ? $('[name="id"]', form) : null;
    var priceEl = $('[data-price]', root);
    var atc = $('[data-atc]', root);

    function currentOptions() {
      return $all('[data-option-selector]', root).map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    /* Produit à variante unique : aucun sélecteur d'option, on prend la 1re variante
       (sinon findVariant([]) renvoie undefined et le stock s'affiche « Épuisé »). */
    function activeVariant() {
      if (!$all('[data-option-selector]', root).length) return variants[0];
      return findVariant(currentOptions());
    }
    function updateSelectedLabels() {
      $all('[data-option-selector]', root).forEach(function (group) {
        var checked = $('input:checked', group);
        var label = $('[data-selected]', group);
        if (checked && label) label.textContent = checked.value;
      });
    }
    function updateStock(v) {
      var el = $('[data-stock]', root);
      if (!el) return;
      var low = parseInt(el.getAttribute('data-low'), 10) || 8;
      var html;
      if (v && v.available) {
        if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
          html = '<span class="stock__dot stock__dot--low"></span><span class="stock__text"><strong>Plus que ' + v.inventory_quantity + ' en stock</strong> — commandez vite</span>';
        } else {
          html = '<span class="stock__dot stock__dot--in"></span><span class="stock__text"><strong>En stock</strong> — prêt à expédier</span>';
        }
      } else {
        html = '<span class="stock__dot stock__dot--out"></span><span class="stock__text"><strong>Épuisé</strong> pour le moment</span>';
      }
      el.innerHTML = html;
    }
    function updatePillAvailability() {
      var current = currentOptions();
      $all('[data-option-selector]', root).forEach(function (group, gi) {
        $all('.variant__pill, .size-paw, .variant__swatch', group).forEach(function (pill) {
          var input = $('input', pill);
          if (!input) return;
          var test = current.slice();
          test[gi] = input.value;
          var match = variants.find(function (vv) {
            return vv.available && vv.options.every(function (o, i) { return test[i] == null || o === test[i]; });
          });
          pill.classList.toggle('variant__pill--soldout', !match);
        });
      });
    }
    function onChange() {
      var opts = currentOptions();
      var v = findVariant(opts);
      updateSelectedLabels();
      updatePillAvailability();
      if (!v) {
        if (atc) { atc.textContent = MF.strings.unavailable; atc.disabled = true; }
        updateStock(null);
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) html += ' <span class="price__compare">' + formatMoney(v.compare_at_price) + '</span>';
        priceEl.innerHTML = html;
      }
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? MF.strings.addToCart : MF.strings.soldOut;
      }
      updateStock(v);
      // Barre collante mobile
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.innerHTML = formatMoney(v.price);
      var stickyBtn = document.querySelector('[data-sticky-atc]');
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? MF.strings.addToCart : MF.strings.soldOut; }
      // MAJ image si variante liée
      if (v.featured_media_index != null) selectMedia(v.featured_media_index);
      // MAJ URL
      if (history.replaceState) {
        var url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }
    $all('[data-option-selector] input', root).forEach(function (input) { on(input, 'change', onChange); });
    updatePillAvailability();
    updateSelectedLabels(); /* le libellé « Couleur : X » doit coller à la pastille cochée dès le chargement */
    updateStock(activeVariant());

    /* Galerie */
    var mainImg = $('[data-main-image]', root);
    function selectMedia(index) {
      var thumb = $('[data-thumb="' + index + '"]', root);
      if (!thumb || !mainImg) return;
      var src = thumb.getAttribute('data-full');
      if (src) mainImg.src = src;
      $all('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }
    $all('[data-thumb]', root).forEach(function (thumb) {
      on(thumb, 'click', function () { selectMedia(parseInt(thumb.getAttribute('data-thumb'), 10)); });
    });
  });

  /* ============================================================
     REVEAL ON SCROLL
     ============================================================ */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $all('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $all('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ============================================================
     RECOMMANDATIONS PRODUIT
     ============================================================ */
  var reco = $('[data-product-recommendations]');
  if (reco && reco.dataset.url) {
    fetch(reco.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-product-recommendations]') || doc.querySelector('section');
      if (fresh && fresh.innerHTML.trim().length) {
        reco.innerHTML = fresh.innerHTML;
        $all('.reveal', reco).forEach(function (el) { el.classList.add('is-in'); });
      }
    }).catch(function () {});
  }

  /* « Complétez l'ensemble » — remplace le repli par les complémentaires Search & Discovery */
  var cLook = $('[data-complete-look]');
  if (cLook && cLook.dataset.url) {
    fetch(cLook.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var items = $all('.cset__item', doc);
      if (items.length) {
        cLook.innerHTML = '';
        items.forEach(function (el) { cLook.appendChild(el); });
      }
    }).catch(function () {});
  }

  /* ============================================================
     AJOUT RAPIDE (délégué — couvre les cartes injectées)
     ============================================================ */
  on(document, 'click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    var id = q.getAttribute('data-variant-id');
    /* Si la carte propose un choix de taille/variante, on prend celui sélectionné. */
    var box = q.closest('.cset__pick') || q.closest('.cset__item') || q.closest('.xsell__item') || q.parentElement;
    var sel = box ? box.querySelector('[data-variant-select]') : null;
    if (sel && sel.value) id = sel.value;
    if (!id) return;
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    addToCart(fd, q);
  });

  /* ============================================================
     RECHERCHE INSTANTANÉE
     ============================================================ */
  var searchOverlay = $('#SearchOverlay');
  if (searchOverlay) {
    var sInput = $('[data-search-input]', searchOverlay);
    var sResults = $('[data-search-results]', searchOverlay);
    var sLastFocus = null, sTimer = null;
    function openSearch() {
      sLastFocus = document.activeElement;
      if (searchOverlay.getAttribute('aria-hidden') === 'false') return; /* déjà ouvert */
      searchOverlay.setAttribute('aria-hidden', 'false');
      setExpanded('[data-search-toggle]', true);
      lockBody();
      setTimeout(function () { if (sInput) sInput.focus(); }, 80);
    }
    function closeSearch() {
      if (searchOverlay.getAttribute('aria-hidden') === 'true') return; /* déjà fermé */
      searchOverlay.setAttribute('aria-hidden', 'true');
      setExpanded('[data-search-toggle]', false);
      unlockBody();
      if (sLastFocus) sLastFocus.focus();
    }
    $all('[data-search-toggle]').forEach(function (b) {
      on(b, 'click', function () {
        if (mobileMenu && mobileMenu.getAttribute('aria-hidden') === 'false') closeMenu();
        openSearch();
      });
    });
    on(searchOverlay, 'click', function (e) { if (e.target.closest('[data-search-close]')) closeSearch(); });
    on(document, 'keydown', function (e) {
      if (searchOverlay.getAttribute('aria-hidden') === 'false') {
        if (e.key === 'Escape') closeSearch(); else trapFocus(searchOverlay, e);
      }
    });
    function renderSearch(products, term) {
      if (!products.length) {
        sResults.innerHTML = '<p class="search-empty">' + (MF.strings.searchEmpty || 'Aucun résultat pour [terme]. Essayez un autre mot.').replace('[terme]', '« ' + escapeHtml(term) + ' »') + '</p>';
        return;
      }
      var html = '<div class="search-results__title">Produits</div><div class="search-results__grid">';
      products.forEach(function (p) {
        var imgUrl = p.image || (p.featured_image && p.featured_image.url) || '';
        var media = imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '<div class="search-hit__ph"><span class="ph-mark" style="font-size:.62rem">' + escapeHtml(MF.shopName || 'Maison Flash') + '</span></div>';
        var priceStr = '';
        if (p.price != null && p.price !== '') priceStr = formatMoney(p.price);
        html += '<a class="search-hit" href="' + p.url + '"><div class="search-hit__media">' + media + '</div>' +
          '<div class="search-hit__title">' + escapeHtml(p.title) + '</div>' +
          (priceStr ? '<div class="search-hit__price">' + priceStr + '</div>' : '') + '</a>';
      });
      html += '</div><a class="btn btn--outline search-view-all" href="' + (MF.searchUrl || '/search') + '?q=' + encodeURIComponent(term) + '">' + (MF.strings.searchViewAll || 'Voir tous les résultats') + '</a>';
      sResults.innerHTML = html;
    }
    var searchSeq = 0;
    function doSearch(q) {
      if (q.trim().length < 2) { sResults.innerHTML = ''; return; }
      sResults.innerHTML = '<p class="search-loading">' + (MF.strings.searchLoading || 'Recherche…') + '</p>';
      var url = ((MF.routes && MF.routes.predictive_search_url) || '/search/suggest.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      var seq = ++searchSeq; /* jeton de séquence : on ignore les réponses hors-ordre */
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (seq !== searchSeq) return; /* une requête plus récente a déjà répondu */
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderSearch(products, q);
        })
        .catch(function () { if (seq === searchSeq) sResults.innerHTML = '<p class="search-empty">Recherche momentanément indisponible.</p>'; });
    }
    if (sInput) on(sInput, 'input', function () { clearTimeout(sTimer); var q = sInput.value; sTimer = setTimeout(function () { doSearch(q); }, 220); });
  }

  /* ============================================================
     BARRE D'ACHAT COLLANTE (fiche produit)
     ============================================================ */
  var stickyBar = $('[data-sticky-bar]');
  if (stickyBar) {
    var pRoot = $('[data-product]');
    var mainAtc = pRoot ? $('[data-atc]', pRoot) : null;
    var pForm = pRoot ? $('form[data-product-form]', pRoot) : null;
    var stickyAtcBtn = $('[data-sticky-atc]', stickyBar);
    if (mainAtc && 'IntersectionObserver' in window) {
      var sObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
          stickyBar.classList.toggle('is-visible', show);
        });
      }, { threshold: 0 });
      sObs.observe(mainAtc);
    }
    if (stickyAtcBtn && pForm) {
      on(stickyAtcBtn, 'click', function () { addToCart(new FormData(pForm), stickyAtcBtn); });
    }
  }

  /* ============================================================
     LIGHTBOX GALERIE
     ============================================================ */
  var lightbox = $('[data-lightbox]');
  if (lightbox) {
    var lbImg = $('[data-lightbox-img]', lightbox);
    var lbClose = $('[data-lightbox-close]', lightbox);
    var lbPrev = $('[data-lightbox-prev]', lightbox);
    var lbNext = $('[data-lightbox-next]', lightbox);
    var lbDots = $('[data-lightbox-dots]', lightbox);
    var lbCount = $('[data-lightbox-count]', lightbox);
    var lbMain = $('[data-main-image]');
    var lbLastFocus = null;

    /* Liste des médias : reprise des miniatures de la galerie produit.
       S'il n'y en a pas, la lightbox se comporte comme avant (image seule). */
    var lbList = [], lbIndex = 0;
    function buildList() {
      lbList = $all('[data-thumb]').map(function (t) {
        return { src: t.getAttribute('data-full'), alt: (t.querySelector('img') || {}).alt || '' };
      }).filter(function (m) { return m.src; });
      var multi = lbList.length > 1;
      [lbPrev, lbNext, lbDots].forEach(function (el) { if (el) el.hidden = !multi; });
      if (lbDots && multi) {
        lbDots.innerHTML = lbList.map(function (_, i) {
          return '<span class="lightbox__dot" data-lb-dot="' + i + '"></span>';
        }).join('');
      }
    }
    function syncUi() {
      if (lbCount) lbCount.textContent = lbList.length > 1 ? (lbIndex + 1) + ' / ' + lbList.length : '';
      if (lbDots) $all('[data-lb-dot]', lbDots).forEach(function (d, i) {
        d.classList.toggle('is-on', i === lbIndex);
      });
    }
    function showIndex(i, dir) {
      if (!lbList.length) return;
      lbIndex = (i + lbList.length) % lbList.length;
      var m = lbList[lbIndex];
      zReset();
      lbImg.style.transition = 'none';
      lbImg.style.opacity = '0';
      if (dir) lbImg.style.transform = 'translateX(' + (dir > 0 ? 24 : -24) + 'px)';
      lbImg.src = m.src; lbImg.alt = m.alt;
      requestAnimationFrame(function () {
        lbImg.style.transition = 'opacity .22s ease, transform .22s ease';
        lbImg.style.opacity = '1';
        lbImg.style.transform = 'translate(0px,0px) scale(1)';
      });
      syncUi();
      /* la miniature suit dans la page */
      var thumb = $('[data-thumb="' + lbIndex + '"]');
      if (thumb) thumb.click();
    }
    function nextLb() { showIndex(lbIndex + 1, 1); }
    function prevLb() { showIndex(lbIndex - 1, -1); }

    function openLb(src, alt) {
      if (!src) return;
      lbLastFocus = document.activeElement;
      buildList();
      var found = lbList.findIndex(function (m) { return m.src === src; });
      lbIndex = found > -1 ? found : 0;
      syncUi();
      lbImg.src = src; lbImg.alt = alt || '';
      lbImg.style.opacity = '1';
      if (lightbox.getAttribute('aria-hidden') === 'false') return; /* déjà ouverte */
      zScale = 1; zX = 0; zY = 0; lbImg.style.transition = 'none'; lbImg.style.transform = ''; lbImg.style.cursor = 'zoom-in'; lightbox.classList.remove('is-zoomed');
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      lockBody();
      setTimeout(function () { if (lbClose) lbClose.focus(); }, 60);
    }
    function closeLb() {
      if (lightbox.getAttribute('aria-hidden') === 'true') return; /* déjà fermée */
      zReset();
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      unlockBody();
      if (lbLastFocus) lbLastFocus.focus();
    }
    /* --- zoom : molette, double-clic, pincement, déplacement --- */
    var zScale = 1, zX = 0, zY = 0, drag = null, pinch = null;
    function zApply() {
      lbImg.style.transform = 'translate(' + zX + 'px,' + zY + 'px) scale(' + zScale + ')';
      lbImg.style.cursor = zScale > 1 ? 'grab' : 'zoom-in';
      lightbox.classList.toggle('is-zoomed', zScale > 1);
    }
    function zReset() { zScale = 1; zX = 0; zY = 0; lbImg.style.transition = 'transform .3s ease'; zApply(); }
    function zClamp() {
      var r = lbImg.getBoundingClientRect();
      var mx = Math.max(0, (r.width * zScale - window.innerWidth) / 2 + 20);
      var my = Math.max(0, (r.height * zScale - window.innerHeight) / 2 + 20);
      zX = Math.min(mx, Math.max(-mx, zX));
      zY = Math.min(my, Math.max(-my, zY));
    }
    function zSet(next, ox, oy) {
      var prev = zScale;
      zScale = Math.min(4, Math.max(1, next));
      if (zScale === 1) { zX = 0; zY = 0; }
      else if (ox != null) {
        var f = zScale / prev;
        zX = ox - (ox - zX) * f;
        zY = oy - (oy - zY) * f;
      }
      zClamp(); zApply();
    }
    on(lbImg, 'wheel', function (e) {
      e.preventDefault();
      lbImg.style.transition = 'none';
      var r = lbImg.getBoundingClientRect();
      zSet(zScale * (e.deltaY < 0 ? 1.14 : 1 / 1.14), e.clientX - (r.left + r.width / 2), e.clientY - (r.top + r.height / 2));
    }, { passive: false });
    on(lbImg, 'dblclick', function (e) {
      lbImg.style.transition = 'transform .3s ease';
      var r = lbImg.getBoundingClientRect();
      zSet(zScale > 1 ? 1 : 2.4, e.clientX - (r.left + r.width / 2), e.clientY - (r.top + r.height / 2));
    });
    on(lbImg, 'click', function (e) { e.stopPropagation(); });
    on(lbImg, 'pointerdown', function (e) {
      if (zScale <= 1) return;
      drag = { x: e.clientX - zX, y: e.clientY - zY };
      lbImg.style.transition = 'none'; lbImg.style.cursor = 'grabbing';
      if (lbImg.setPointerCapture) lbImg.setPointerCapture(e.pointerId);
    });
    on(lbImg, 'pointermove', function (e) {
      if (!drag) return;
      zX = e.clientX - drag.x; zY = e.clientY - drag.y; zClamp(); zApply();
    });
    on(lbImg, 'pointerup', function () { drag = null; lbImg.style.cursor = zScale > 1 ? 'grab' : 'zoom-in'; });
    on(lbImg, 'pointercancel', function () { drag = null; });
    function pdist(t) { var a = t[0], b = t[1]; return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    on(lbImg, 'touchstart', function (e) {
      if (e.touches.length === 2) { pinch = { d: pdist(e.touches), s: zScale }; lbImg.style.transition = 'none'; }
    }, { passive: true });
    on(lbImg, 'touchmove', function (e) {
      if (pinch && e.touches.length === 2) { e.preventDefault(); zSet(pinch.s * (pdist(e.touches) / pinch.d), 0, 0); }
    }, { passive: false });
    on(lbImg, 'touchend', function () { pinch = null; });

    function openFromMain() { if (lbMain) openLb(lbMain.src, lbMain.alt); }
    if (lbMain) {
      on(lbMain, 'click', openFromMain);
      on(lbMain, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openFromMain(); } });
    }
    on(lbPrev, 'click', function (e) { e.stopPropagation(); prevLb(); });
    on(lbNext, 'click', function (e) { e.stopPropagation(); nextLb(); });
    on(lbDots, 'click', function (e) {
      var d = e.target.closest('[data-lb-dot]');
      if (d) { e.stopPropagation(); showIndex(parseInt(d.getAttribute('data-lb-dot'), 10)); }
    });
    on(lightbox, 'click', function (e) { if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) closeLb(); });
    on(document, 'keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeLb(); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); nextLb(); return; }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prevLb(); return; }
      trapFocus(lightbox, e);
    });

    /* Glissement au doigt : change d'image quand on n'est PAS zoomé,
       sinon on laisse le déplacement de l'image faire son travail. */
    var swX = null, swY = null;
    on(lbImg, 'touchstart', function (e) {
      if (zScale > 1 || e.touches.length !== 1) { swX = null; return; }
      swX = e.touches[0].clientX; swY = e.touches[0].clientY;
    }, { passive: true });
    on(lbImg, 'touchend', function (e) {
      if (swX === null || zScale > 1) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - swX, dy = t.clientY - swY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { dx < 0 ? nextLb() : prevLb(); }
      swX = null;
    });
  }

  /* ============================================================
     DATE DE LIVRAISON — PANIER (même logique que la fiche produit)
     ============================================================ */
  (function () {
    var box = $('[data-cart-eta]');
    if (!box) return;
    var out = $('[data-cart-eta-text]', box);
    var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    function fmt(d) { return JOURS[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()]; }
    function addBiz(from, n) {
      var d = new Date(from.getTime());
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    function render() {
      var min = parseInt(box.getAttribute('data-min'), 10) || 2;
      var max = parseInt(box.getAttribute('data-max'), 10) || 4;
      var cutoff = parseInt(box.getAttribute('data-cutoff'), 10);
      if (isNaN(cutoff)) cutoff = 14;
      var now = new Date();
      var ship = new Date(now.getTime());
      if (now.getHours() >= cutoff) ship.setDate(ship.getDate() + 1);
      while (ship.getDay() === 0 || ship.getDay() === 6) ship.setDate(ship.getDate() + 1);
      var a = addBiz(ship, min), b = addBiz(ship, max);
      out.innerHTML = (MF.strings.deliveryEst || 'Livraison estimée entre [debut] et [fin]').replace('[debut]', '<strong>' + fmt(a) + '</strong>').replace('[fin]', '<strong>' + fmt(b) + '</strong>');
    }
    render();
  })();

  /* ============================================================
     MODALE GUIDE DES TAILLES
     ============================================================ */
  var sizeModal = $('[data-size-modal]');
  if (sizeModal) {
    var smLastFocus = null;
    function openSize() {
      if (sizeModal.getAttribute('aria-hidden') === 'false') return; /* déjà ouverte */
      smLastFocus = document.activeElement;
      sizeModal.classList.add('is-open');
      sizeModal.setAttribute('aria-hidden', 'false');
      lockBody();
      setTimeout(function () { var c = $('[data-size-close]', sizeModal); if (c) c.focus(); }, 60);
    }
    function closeSize() {
      if (sizeModal.getAttribute('aria-hidden') === 'true') return; /* déjà fermée */
      sizeModal.classList.remove('is-open');
      sizeModal.setAttribute('aria-hidden', 'true');
      unlockBody();
      if (smLastFocus) smLastFocus.focus();
    }
    $all('[data-size-open]').forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); openSize(); });
    });
    on(sizeModal, 'click', function (e) {
      if (e.target === sizeModal || e.target.closest('[data-size-close]')) closeSize();
    });
    on(document, 'keydown', function (e) {
      if (!sizeModal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeSize(); else trapFocus(sizeModal, e);
    });
  }

  /* ============================================================
     RETOUR EN HAUT
     ============================================================ */
  var btt = $('[data-back-to-top]');
  if (btt) {
    on(btt, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    var bttScroll = function () { btt.classList.toggle('is-visible', window.scrollY > 600); };
    on(window, 'scroll', bttScroll, { passive: true });
    bttScroll();
  }

  /* ============================================================
     ANNONCE ROTATIVE
     ============================================================ */
  var annMsgs = $all('.announcement__msg');
  if (annMsgs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var annIdx = 0, annTimer = null;
    var annRoot = annMsgs[0].closest('.announcement') || document;
    function annTick() {
      annMsgs[annIdx].hidden = true;
      annIdx = (annIdx + 1) % annMsgs.length;
      annMsgs[annIdx].hidden = false;
    }
    function annStart() { if (!annTimer) annTimer = setInterval(annTick, 4200); }
    function annStop() { if (annTimer) { clearInterval(annTimer); annTimer = null; } }
    on(annRoot, 'mouseenter', annStop);
    on(annRoot, 'mouseleave', annStart);
    on(annRoot, 'focusin', annStop);
    on(annRoot, 'focusout', annStart);
    annStart();
  }

  /* ============================================================
     LIVRAISON ESTIMÉE (fiche produit)
     ============================================================ */
  (function () {
    var box = $('[data-delivery]');
    if (!box) return;
    var shipLine = $('[data-ship-line]', box);
    var etaLine = $('[data-eta-line]', box);
    var cutBox = $('[data-cutoff-line]', box);
    var cutText = $('[data-cutoff-text]', box);
    var min = parseInt(box.dataset.min, 10) || 2;
    var max = parseInt(box.dataset.max, 10) || 4;
    var cutoff = parseInt(box.dataset.cutoff, 10); if (isNaN(cutoff)) cutoff = 14;
    var skip = box.dataset.skipWeekend !== 'false';
    var carrier = (box.dataset.carrier || '').trim();
    if (max < min) { var t = min; min = max; max = t; }

    function isWeekend(d) { var g = d.getDay(); return g === 0 || g === 6; }
    function frDate(d) { return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }); }
    function addBusinessDays(from, n) {
      var d = new Date(from), added = 0;
      while (added < n) { d.setDate(d.getDate() + 1); if (!skip || !isWeekend(d)) added++; }
      return d;
    }
    function render() {
      var now = new Date();
      var shipsToday = (!skip || !isWeekend(now)) && now.getHours() < cutoff;
      var shipDate = new Date(now);
      if (!shipsToday) { do { shipDate.setDate(shipDate.getDate() + 1); } while (skip && isWeekend(shipDate)); }
      var label;
      if (shipsToday) label = "aujourd'hui";
      else {
        var tmr = new Date(now); tmr.setDate(now.getDate() + 1);
        label = shipDate.toDateString() === tmr.toDateString() ? 'demain' : frDate(shipDate);
      }
      if (shipLine) shipLine.textContent = 'Expédié ' + label; /* le transporteur est déjà affiché par la puce .delivery__carrier — pas de doublon */
      var etaMin = addBusinessDays(shipDate, min);
      var etaMax = addBusinessDays(shipDate, max);
      if (etaLine) {
        /* Une seule date, la borne haute : promesse tenable et lisible */
        etaLine.innerHTML = 'Recevez-le d’ici <b>le ' + frDate(etaMax) + '</b>';
      }
      if (cutBox && cutText) {
        if (shipsToday) {
          var cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
          var diff = cut - now;
          if (diff > 0) {
            var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000);
            cutText.textContent = (MF.strings.deliveryCutoff || 'Commandez dans les [temps] pour un envoi aujourd\'hui').replace('[temps]', (h > 0 ? h + ' h ' : '') + m + ' min');
            cutBox.hidden = false;
          } else { cutBox.hidden = true; }
        } else { cutBox.hidden = true; }
      }
    }
    render();
    setInterval(render, 30000);
  })();

  /* Initial cart sync (compteur) */
  getCart().then(function (cart) { updateCartCount(cart.item_count); renderDrawer(cart); }).catch(function () {});
})();
